function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.typed.uint8-array.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import moment from 'moment-timezone';
import DateService from "../services/DateService";
import Security from "./Security";
import lodash from 'lodash';
export default {
  mixins: [Security],
  computed: {
    common: function common() {
      return this.$store.state.common.data;
    }
  },
  data: function data() {
    return {
      rowsPerPageOptions: [5, 10, 15, 25, 50],
      editorOptions: [[{
        label: this.$q.lang.editor.align,
        icon: this.$q.iconSet.editor.align,
        fixedLabel: true,
        list: 'only-icons',
        options: ['left', 'center', 'right', 'justify']
      }, {
        label: this.$q.lang.editor.align,
        icon: this.$q.iconSet.editor.align,
        fixedLabel: true,
        options: ['left', 'center', 'right', 'justify']
      }], ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'], ['token', 'hr', 'link'], ['quote', 'unordered', 'ordered', 'outdent', 'indent'], ['undo', 'redo']]
    };
  },
  methods: {
    pasteCapture: function pasteCapture(evt, ref) {
      // Let inputs do their thing, so we don't break pasting of links.
      if (evt.target.nodeName === 'INPUT') return;
      var text, onPasteStripFormattingIEPaste;
      evt.preventDefault();
      if (evt.originalEvent && evt.originalEvent.clipboardData.getData) {
        text = evt.originalEvent.clipboardData.getData('text/plain');
        this.$refs[ref].runCmd('insertText', text);
      } else if (evt.clipboardData && evt.clipboardData.getData) {
        text = evt.clipboardData.getData('text/plain');
        this.$refs[ref].runCmd('insertText', text);
      } else if (window.clipboardData && window.clipboardData.getData) {
        if (!onPasteStripFormattingIEPaste) {
          onPasteStripFormattingIEPaste = true;
          this.$refs[ref].runCmd('ms-pasteTextOnly', text);
        }
        onPasteStripFormattingIEPaste = false;
      }
    },
    confirmDelete: function confirmDelete(message) {
      return this.$q.dialog({
        title: 'Are you sure?',
        message: message,
        ok: {
          color: 'primary',
          flat: false
        },
        cancel: {
          color: 'secondary',
          flat: true
        }
      });
    },
    notifyPositive: function notifyPositive(message) {
      this.$q.notify({
        color: 'positive',
        icon: 'check',
        message: message,
        position: 'bottom'
      });
    },
    notifyNegative: function notifyNegative(message) {
      this.$q.notify({
        color: 'negative',
        icon: 'delete',
        message: message,
        position: 'bottom'
      });
    },
    notifyWarning: function notifyWarning(message) {
      this.$q.notify({
        color: 'warning',
        icon: 'warning',
        message: message,
        position: 'bottom'
      });
    },
    qtColumns: function qtColumns(data) {
      var _this = this;
      var columns = [];
      data.forEach(function (obj) {
        var col = {};
        col.name = obj.name;
        col.field = obj.field;
        col.label = obj.label;
        col.align = obj.align ? obj.align : 'left';
        col.sortable = obj.sortable;
        col.style = obj.style;
        col.classes = obj.classes;
        col.format = obj.format;
        if (obj.type === 'int' || obj.type === 'currency') {
          col.sort = function (a, b) {
            return parseInt(a, 10) - parseInt(b, 10);
          };
          if (obj.type === 'currency') {
            col.format = function (val) {
              return _this.$options.filters.currency(val);
            };
          }
        }
        if (obj.type === 'date') {
          col.sort = function (a, b) {
            return moment(a, 'DD/MM/YYYY') - moment(b, 'DD/MM/YYYY');
          };
        }
        if (obj.type === 'dbDate') {
          col.sort = function (a, b) {
            return moment(a, 'YYYY-MM-DD') - moment(b, 'YYYY-MM-DD');
          };
          col.format = function (val) {
            return DateService.fromDbDate(val, 1);
          };
        }
        if (obj.val) {
          col.val = obj.val;
        }
        columns.push(col);
      });
      return columns;
    },
    detectIE: function detectIE() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }
      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }
      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        return 'Edge';
      }
      return false;
    },
    b64toBlob: function b64toBlob(b64Data, contentType) {
      contentType = contentType || '';
      var sliceSize = 512;
      b64Data = b64Data.replace(/^[^,]+,/, '');
      b64Data = b64Data.replace(/\s/g, '');
      var byteCharacters = window.atob(b64Data);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays, {
        type: contentType
      });
    },
    csvNames: function csvNames(data) {
      var _this2 = this;
      data.forEach(function (o) {
        if (!o.website) {
          o.website = '';
        }
        if (!o.email) {
          o.email = '';
        }
        if (!o.phone) {
          o.phone = '';
        } else {
          o.phone = _this2.formatPhone(o.phone);
        }
        if (o.services) {
          var services = '';
          var _iterator = _createForOfIteratorHelper(o.services),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var s = _step.value;
              if (services !== '') {
                services += ', ';
              }
              services += s.name;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          o.servicesString = services;
        }
      });
      return data;
    },
    fromNowDate: function fromNowDate(val) {
      if (val === moment().format('DD/MM/YYYY')) {
        return 'today';
      }
      return moment(val, 'DD/MM/YYYY').fromNow();
    },
    fromNowTz: function fromNowTz(val) {
      return moment.tz(moment(val).subtract(1, 'seconds'), this.user.timezone ? this.user.timezone : moment.tz.guess()).fromNow();
    },
    dateTimeTz: function dateTimeTz(val) {
      if (!val) {
        return;
      }
      return moment.tz(val, this.user.timezone ? this.user.timezone : moment.tz.guess()).format('DD/MM/YYYY HH:mm:ss');
    },
    isToday: function isToday(val) {
      return moment().format('DD/MM/YYYY') === val;
    },
    getRowsPerPage: function getRowsPerPage() {
      return localStorage.getItem('rowsPerPage') ? localStorage.getItem('rowsPerPage') : 15;
    },
    setRowsPerPage: function setRowsPerPage(val) {
      localStorage.setItem('rowsPerPage', val);
    },
    nl2br: function nl2br(str) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = '<br />';
      // eslint-disable-next-line
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    getTimeZones: function getTimeZones() {
      var data = [];
      var _iterator2 = _createForOfIteratorHelper(moment.tz.names()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var t = _step2.value;
          if (t.match('Australia')) {
            data.push({
              label: t,
              value: t
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return data;
    },
    awsSesStatus: function awsSesStatus(val) {
      if (val === 'Send') {
        return 'Sent';
      }
      if (val === 'Delivery') {
        return 'Delivered';
      }
      if (val === 'Open') {
        return 'Opened';
      }
      if (val === 'Bounce') {
        return 'Failed';
      }
      if (val === 'Click') {
        return 'Clicked';
      }
      return val;
    },
    groupBy: function groupBy(data, key) {
      return lodash.chain(data)
      // Group the elements of Array based on `color` property
      .groupBy(key)
      // `key` is group's name (color), `value` is the array of objects
      .map(function (value, key) {
        return {
          key: key,
          data: value
        };
      }).value();
    },
    logout: function logout() {
      window.location = '/api/auth/logout?from=portal';
    },
    gotoRef: function gotoRef(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    formatPhone: function formatPhone(phone) {
      var tmpPhone = phone.replace('+61', '');
      // mobile
      if (tmpPhone.length === 9 && tmpPhone.substr(0, 1) === '4') {
        return "0".concat(tmpPhone.substr(0, 3), " ").concat(tmpPhone.substr(3, 3), " ").concat(tmpPhone.substr(6, 3));
      }
      // landline
      if (tmpPhone.length === 9 && tmpPhone.substr(0, 1) !== '4') {
        return "(0".concat(tmpPhone.substr(0, 1), ") ").concat(tmpPhone.substr(1, 4), " ").concat(tmpPhone.substr(5, 4));
      }
      // 13
      if (tmpPhone.substr(0, 2) === '13' && tmpPhone.length === 6) {
        return "".concat(tmpPhone.substr(0, 2), " ").concat(tmpPhone.substr(2, 2), " ").concat(tmpPhone.substr(4, 2));
      }
      // 1300 or 1800
      if ((tmpPhone.substr(0, 4) === '1300' || tmpPhone.substr(0, 4) === '1800') && tmpPhone.length > 6) {
        return "".concat(tmpPhone.substr(0, 4), " ").concat(tmpPhone.substr(4, 3), " ").concat(tmpPhone.substr(7, 3));
      }
      return tmpPhone;
    },
    sortByKey: function sortByKey(arr, key) {
      var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'desc';
      var keyType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'date';
      var firstVal = 1;
      var secondVal = -1;
      if (direction === 'desc') {
        firstVal = -1;
        secondVal = 1;
      }
      arr.sort(function (a, b) {
        if (keyType === 'date') {
          return lodash.get(a, key) > lodash.get(b, key) ? firstVal : secondVal;
        }
        if (keyType === 'dateDisplay') {
          return moment(lodash.get(a, key), 'DD/MM/YYYY').isAfter(moment(lodash.get(b, key), 'DD/MM/YYYY')) ? firstVal : secondVal;
        }
        if (keyType === 'number') {
          return parseFloat(lodash.get(a, key)) > parseFloat(lodash.get(b, key)) ? firstVal : secondVal;
        }
        if (keyType === 'string') {
          return lodash.get(a, key).localeCompare(lodash.get(b, key)) ? firstVal : secondVal;
        }
      });
      return arr;
    }
  }
};